import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import TokenMigrationBadge from '../TokenMigration/Badge'
import Amounts from './Amounts'
import H from '~shared/Hero'
import Container from '~shared/Container'
import ButtonWrapper from '~shared/ButtonWrapper'
import Display from '~shared/Display'
import Spacer from '~shared/Spacer'
import PriceGraph from '~shared/PriceGraph'
import GraphNav from '~shared/PriceGraph/Nav'
import useHistoricalDataTokenStream from '~hooks/useHistoricalDataTokenStream'

const AmountsSpacer = styled(Spacer)`
    background-color: #FCFCFC;
`

const Buttons = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 3rem;

    > * {
        flex: 1;
    }

    > * + * {
        margin-top: 1.5rem;
    }

    @media (min-width: ${TABLET}px) {
        flex-direction: row;
        justify-content: center;
        margin-top: 6rem;

        > *:first-child {
            text-align: right;
            margin-right: 1.5rem;
        }

        > *:last-child {
            margin-left: 1.5rem;
        }

        > * + * {
            margin-top: 0;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        margin-top: 5rem;

        > *:first-child {
            margin-right: 2rem;
        }

        > *:last-child {
            margin-left: 2rem;
        }
    }
`

const UnstyledHero = (props) => {
    const {
        today,
        week,
        month,
        year,
        all,
    } = useHistoricalDataTokenStream()

    const [selectedInterval, setSelectedInterval] = useState('today')

    const selectedData = () => {
        switch (selectedInterval) {
            case GraphNav.Timeframe.TODAY:
                return today
            case GraphNav.Timeframe.SEVEN_DAYS:
                return week
            case GraphNav.Timeframe.ONE_MONTH:
                return month
            case GraphNav.Timeframe.ONE_YEAR:
                return year
            case GraphNav.Timeframe.ALL:
                return all
            default:
                return today
        }
    }

    return (
        <div {...props}>
            <Container>
                <H.Headline $appear>
                    The DATA token
                </H.Headline>
                <H.Paragraph $appear>
                    The DATA token is an ERC-20 token used for project
                    governance, to incentivize the Network, to delegate
                    stake on broker nodes, and for Marketplace payments.
                </H.Paragraph>
            </Container>
            <Display as={Spacer} mobile="none" tablet="block" head=",3rem,3.5rem">
                <Container>
                    <GraphNav
                        switchTimeframe={setSelectedInterval}
                        loading={!today.length}
                        $appear
                    />
                </Container>
                <Spacer as={Container} head="40px," $appear>
                    <TokenMigrationBadge />
                </Spacer>
                <Spacer head="13rem">
                    <PriceGraph
                        points={selectedData()}
                        showTime={[GraphNav.Timeframe.TODAY, GraphNav.Timeframe.SEVEN_DAYS].includes(selectedInterval)}
                        theme={{
                            background: '#FFFFFF',
                            area: '#FCFCFC',
                        }}
                    />
                </Spacer>
            </Display>
            <AmountsSpacer pad head="4rem,6.5rem,9.5rem" tail="5rem,10.5rem,15.5rem">
                <Container>
                    <Amounts />
                    <Display tablet="none">
                        <Spacer head="40px,32px,">
                            <TokenMigrationBadge />
                        </Spacer>
                    </Display>
                    <Buttons>
                        <div>
                            <ButtonWrapper>
                                <Button
                                    tag="a"
                                    kind="primary"
                                    size="big"
                                    href={`https://etherscan.io/address/${process.env.GATSBY_NEW_TOKEN_ADDRESS}`}
                                    rel="noreferrer noopener"
                                    target="_blank"
                                >
                                    View token contract
                                </Button>
                            </ButtonWrapper>
                        </div>
                        <div>
                            <ButtonWrapper>
                                <Button
                                    tag="a"
                                    kind="primary"
                                    size="big"
                                    href="https://messari.io/asset/streamr/profile"
                                    rel="noreferrer noopener"
                                    target="_blank"
                                    outline
                                >
                                    View Messari profile
                                </Button>
                            </ButtonWrapper>
                        </div>
                    </Buttons>
                </Container>
            </AmountsSpacer>
        </div>
    )
}

const Hero = styled(UnstyledHero)`
    position: relative;

    ${GraphNav} {
        background-color: #FAFAFA;
    }

    @media (min-width: ${TABLET}px) {
        ${Container} {
            max-width: 32rem;
        }

        ${H.Paragraph} {
            margin: 0;
            max-width: 456px;
        }

        ${GraphNav} {
            max-width: 424px;
            box-sizing: border-box;
            padding: 12px 32px 22px 32px;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Container} {
            max-width: 72.5rem;
        }

        ${H.Headline} {
            text-align: left;
        }
    }

    @media (max-width: ${TABLET - 1}px) {
        ${TokenMigrationBadge} {
            background-color: #FFFFFF;
        }

        ::before {
            content: '';
            background-color: #FAFAFA;
            width: 100%;
            height: 200%;
            position: absolute;
            bottom: 0;
            z-index: -1;
        }
    }
`

export default Hero
